/*
 * Homeline shop catalog (sections/shop-catalog.liquid), Oct 2026 "Collection
 * Header & Glass Filters" handoff.
 *
 * The whole catalogue is rendered once and filtered here, so switching range,
 * category, chip, stock or sort never reloads the page. Filtering keys off
 * the data attributes each cell carries:
 *   range    data-range: signature | essentials | both (range: tags)
 *   category data-cat (product type mapped to a Homeline category)
 *   chips    data-subs (sub: tags)
 *   New In   data-newin (new-in tag)
 *   stock    data-instock
 *
 * State is mirrored in the URL (?range=&cat=&sub=&available=1&sort_by=&q=)
 * with replaceState, so a shared link or a refresh lands on the same view.
 *
 * Rule from the handoff: the range switch's resting position and colours come
 * from state alone (a data attribute and CSS). Script only adds the drag on
 * top, so nothing selected ever depends on an animation frame running.
 */
(function () {
  'use strict';

  // Canonical sub-category order per category. A sub: tag outside this list
  // is ignored, and only chips the catalogue has products for are shown.
  var SUBCATS = {
    Sofas: ['Fabric', 'Leather', '1-Seat', '2-Seat', '2.5-Seat', '3-Seat', 'Corner', 'Chaise', 'Modular', 'Recliner', 'Powered', 'Sofa Beds', 'Recliner Suite', 'Lounge Suite', 'Ottoman', 'Armchairs'],
    Dining: ['Tables', 'Chairs', 'Bar Stools', 'Buffets'],
    Living: ['Coffee Tables', 'TV Units', 'Side Tables', 'Hallway Tables'],
    Homeware: ['Cushions', 'Throws', 'Wall Art', 'Candles', 'Vases', 'Kitchen']
  };

  var RANGES = ['all', 'signature', 'essentials'];
  var LINES = {
    all: 'Signature and Essentials, side by side.',
    signature: 'Home well made.',
    essentials: 'Home made easy.'
  };
  // [key, full label, short label (mobile), Shopify sort_by]
  var SORTS = [
    ['featured', 'Featured', 'Featured', ''],
    ['low', 'Price, low to high', 'Price ↑', 'price-ascending'],
    ['high', 'Price, high to low', 'Price ↓', 'price-descending'],
    ['new', 'Newest', 'Newest', 'created-descending']
  ];
  var CHECK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5"/></svg>';
  var X = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function mobile() {
    return window.matchMedia('(max-width: 960px)').matches;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /*
    Both halves of a filter are typed by hand (sub: tags in the product admin,
    ?cat=&sub= links in the menu editor), so compare on letters and digits
    alone and let a trailing plural slide.
  */
  function slug(value) {
    return String(value == null ? '' : value)
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '')
      .replace(/s$/, '');
  }

  function resolveName(value, candidates) {
    var target = slug(value);
    if (!target) return '';
    for (var i = 0; i < candidates.length; i++) {
      if (slug(candidates[i]) === target) return candidates[i];
    }
    return '';
  }

  function sortDef(key) {
    for (var i = 0; i < SORTS.length; i++) if (SORTS[i][0] === key) return SORTS[i];
    return SORTS[0];
  }

  function Shop(root) {
    var self = this;
    this.root = root;
    var $ = function (sel) {
      return root.querySelector(sel);
    };

    this.cells = Array.prototype.slice.call(root.querySelectorAll('.hl-shop__cell'));
    this.grid = $('[data-hl-grid]');
    this.block = $('[data-hl-block]');
    this.hero = $('[data-hl-hero]');
    this.title = $('[data-hl-resulttitle]');
    this.line = $('[data-hl-line]');
    this.seg = $('[data-hl-seg]');
    this.lens = $('[data-hl-lens]');
    this.segOpts = Array.prototype.slice.call(root.querySelectorAll('.hl-seg__opt'));
    this.catBtns = Array.prototype.slice.call(root.querySelectorAll('.hl-shop__cat'));
    this.chipWrap = $('[data-hl-chipwrap]');
    this.chips = $('[data-hl-chips]');
    this.chipsNext = $('[data-hl-chips-next]');
    this.count = $('[data-hl-count]');
    this.tokens = $('[data-hl-tokens]');
    this.stockBtn = $('[data-hl-instock]');
    this.sortBtn = $('[data-hl-sort-btn]');
    this.sortLabel = $('[data-hl-sort-label]');
    this.sortPop = $('[data-hl-sort-pop]');
    this.empty = $('[data-hl-empty]');
    this.emptyTitle = $('[data-hl-empty-title]');
    this.emptyText = $('[data-hl-empty-text]');
    this.emptyClear = $('[data-hl-empty-clear]');

    // The compact bar lives under <body>: a transformed ancestor (a reveal
    // wrapper) would otherwise pin its position: fixed to the page.
    this.bar = $('[data-hl-bar]');
    if (this.bar) {
      document.body.appendChild(this.bar);
      this.barTitle = this.bar.querySelector('[data-hl-bar-title]');
      this.barCount = this.bar.querySelector('[data-hl-bar-count]');
      this.barChips = this.bar.querySelector('[data-hl-bar-chips]');
      this.barBtn = this.bar.querySelector('[data-hl-bar-btn]');
      this.barSort = this.bar.querySelector('[data-hl-bar-sort]');
      this.barDot = this.bar.querySelector('[data-hl-bar-dot]');
      this.barPop = this.bar.querySelector('[data-hl-bar-pop]');
      this.barStock = this.bar.querySelector('[data-hl-bar-stock]');
      this.barSorts = this.bar.querySelector('[data-hl-bar-sorts]');
      this.bar.hidden = false;
      this.bar.inert = true;
    }

    this.comingSoon = (root.getAttribute('data-coming-soon') || '')
      .split(',')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);

    this.catNames = this.catBtns.map(function (b) {
      return b.getAttribute('data-cat');
    });
    this.defaultCat =
      this.catNames.filter(function (c) {
        return c !== 'New In';
      })[0] ||
      this.catNames[0] ||
      'All';
    this.allSubs = Object.keys(SUBCATS).reduce(function (acc, k) {
      return acc.concat(SUBCATS[k]);
    }, []);

    // Which chips actually have products, per category, and how many
    // products each category has at all (an empty one reads "coming soon").
    this.present = {};
    this.catSize = {};
    this.cells.forEach(function (cell) {
      var cat = cell.getAttribute('data-cat');
      if (!self.present[cat]) self.present[cat] = {};
      self.catSize[cat] = (self.catSize[cat] || 0) + 1;
      cell.hlSubs = (cell.getAttribute('data-subs') || '')
        .split('|')
        .filter(Boolean)
        .map(function (s) {
          return resolveName(s, self.allSubs) || s;
        });
      cell.hlIndex = self.cells.indexOf(cell);
      cell.hlSubs.forEach(function (s) {
        self.present[cat][s] = true;
      });
    });

    // ---- initial state from the URL, then the template preset ----
    var params = new URLSearchParams(location.search);
    var q = (params.get('q') || '').trim();
    var cat =
      resolveName(params.get('cat'), this.catNames) ||
      resolveName(root.getAttribute('data-initial-cat'), this.catNames) ||
      (q ? 'All' : this.defaultCat);
    var range = (params.get('range') || '').trim().toLowerCase();
    var sortBy = params.get('sort_by') || params.get('sort') || '';
    var sort = 'featured';
    SORTS.forEach(function (d) {
      if (d[3] && d[3] === sortBy) sort = d[0];
      if (d[0] === sortBy) sort = d[0];
    });
    this.state = {
      range: RANGES.indexOf(range) > -1 ? range : root.getAttribute('data-initial-range') || 'all',
      cat: cat,
      sub: resolveName(params.get('sub'), SUBCATS[cat] || []) || 'All',
      q: q,
      sort: sort,
      stock: params.get('available') === '1' || params.get('filter.v.availability') === '1'
    };

    this.bindSeg();
    this.bindControls();
    this.bindBar();
    this.renderSorts();
    this.update(true);
  }

  /* ─────────────── range switch ─────────────── */

  Shop.prototype.cell = function () {
    // The lens is (padding box − 8px) / 3 wide; the grid columns match it.
    return (this.seg.clientWidth - 8) / 3;
  };

  Shop.prototype.bindSeg = function () {
    var self = this;
    var seg = this.seg;
    if (!seg) return;

    var drag = null;

    var rubber = function (o, d) {
      return (o * d * 0.55) / (d + 0.55 * Math.abs(o));
    };

    var hoverIndex = function (x) {
      return Math.max(0, Math.min(2, Math.round(x / self.cell())));
    };

    var paintDrag = function (x, vel) {
      var stretch = Math.min(0.1, Math.abs(vel || 0) / 6000);
      self.lens.style.transform =
        'translateX(' + x.toFixed(1) + 'px) scale(' + (1.12 + stretch).toFixed(3) + ',' + (1.12 - stretch / 2).toFixed(3) + ')';
      var hi = hoverIndex(x);
      seg.setAttribute('data-hover', RANGES[hi]);
    };

    seg.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      var r = seg.getBoundingClientRect();
      var cell = self.cell();
      var x0 = RANGES.indexOf(self.state.range) * cell;
      var lensL = r.left + 5 + x0;
      var onLens = e.clientX >= lensL && e.clientX <= lensL + cell;
      drag = { id: e.pointerId, sx: e.clientX, x0: x0, moved: false, onLens: onLens, x: x0, v: 0, hist: [{ x: e.clientX, t: performance.now() }] };
      try {
        seg.setPointerCapture(e.pointerId);
      } catch (err) {}
      if (onLens) seg.classList.add('is-pressed');
    });

    seg.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var now = performance.now();
      if (!drag.moved && Math.abs(e.clientX - drag.sx) < 6) return;
      var cell = self.cell();
      var max = 2 * cell;
      if (!drag.moved) {
        drag.moved = true;
        // Started off the lens: the lens jumps under the finger.
        if (!drag.onLens) {
          drag.x0 = Math.max(0, Math.min(max, e.clientX - seg.getBoundingClientRect().left - 5 - cell / 2));
          drag.sx = e.clientX;
        }
        seg.classList.add('is-pressed', 'is-dragging');
      }
      drag.hist.push({ x: e.clientX, t: now });
      while (drag.hist.length > 2 && now - drag.hist[0].t > 100) drag.hist.shift();
      var x = drag.x0 + (e.clientX - drag.sx);
      if (x < 0) x = -rubber(-x, cell);
      else if (x > max) x = max + rubber(x - max, cell);
      var a = drag.hist[0];
      var b = drag.hist[drag.hist.length - 1];
      var dt = (b.t - a.t) / 1000;
      drag.v = dt > 0 ? (b.x - a.x) / dt : 0;
      drag.x = x;
      paintDrag(x, drag.v);
    });

    var end = function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag;
      drag = null;
      var cell = self.cell();
      var i;
      if (!d.moved) {
        i = Math.max(0, Math.min(2, Math.floor((e.clientX - seg.getBoundingClientRect().left - 5) / cell)));
      } else {
        // Where a flick would carry it, snapped to the nearest option.
        var proj = d.x + ((d.v || 0) / 1000) * 0.99 / (1 - 0.99);
        i = Math.max(0, Math.min(2, Math.round(proj / cell)));
      }
      // Hand back to CSS: dropping the inline transform lets the state's
      // transition carry the lens from where the finger left it.
      seg.classList.remove('is-pressed', 'is-dragging');
      seg.removeAttribute('data-hover');
      self.lens.style.transform = '';
      if (e.type === 'pointercancel' && !d.moved) return;
      self.setRange(RANGES[i]);
    };
    seg.addEventListener('pointerup', end);
    seg.addEventListener('pointercancel', end);

    // Keyboard: the options are real buttons; arrows move between them.
    this.segOpts.forEach(function (btn, i) {
      btn.addEventListener('click', function (e) {
        // Pointer clicks are handled on pointerup above.
        if (e.detail !== 0) return;
        self.setRange(btn.getAttribute('data-range'));
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var next = self.segOpts[(i + (e.key === 'ArrowRight' ? 1 : 2)) % 3];
        next.focus();
        self.setRange(next.getAttribute('data-range'));
      });
    });
  };

  Shop.prototype.setRange = function (range) {
    if (RANGES.indexOf(range) === -1) return;
    this.state.range = range;
    this.update();
  };

  /* ─────────────── chips, stock, sort ─────────────── */

  Shop.prototype.bindControls = function () {
    var self = this;

    this.catBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.state.cat = btn.getAttribute('data-cat');
        self.state.sub = 'All';
        self.update();
      });
    });

    [this.chips, this.barChips].forEach(function (row) {
      if (!row) return;
      row.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-sub]');
        if (!chip) return;
        self.state.sub = chip.getAttribute('data-sub');
        self.update();
        self.revealChip();
      });
    });

    if (this.chipsNext) {
      this.chipsNext.addEventListener('click', function () {
        self.chips.scrollBy({ left: 320, behavior: reduced() ? 'auto' : 'smooth' });
      });
      this.chips.addEventListener('scroll', function () {
        self.paintChipsNext();
      }, { passive: true });
      window.addEventListener('resize', function () {
        self.paintChipsNext();
      }, { passive: true });
    }

    [this.stockBtn, this.barStock].forEach(function (btn) {
      if (!btn) return;
      btn.addEventListener('click', function () {
        self.state.stock = !self.state.stock;
        self.update();
      });
      // Pressed, the knob widens.
      btn.addEventListener('pointerdown', function () {
        btn.classList.add('is-press');
      });
      ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (t) {
        btn.addEventListener(t, function () {
          btn.classList.remove('is-press');
        });
      });
    });

    if (this.tokens) {
      this.tokens.addEventListener('click', function (e) {
        var t = e.target.closest('[data-clear]');
        if (!t) return;
        var what = t.getAttribute('data-clear');
        if (what === 'sub') self.state.sub = 'All';
        else if (what === 'stock') self.state.stock = false;
        else if (what === 'range') self.state.range = 'all';
        else if (what === 'q') self.clearSearch();
        self.update();
      });
    }

    if (this.emptyClear) {
      this.emptyClear.addEventListener('click', function () {
        self.state.sub = 'All';
        self.state.stock = false;
        self.state.range = 'all';
        if (self.state.q) self.clearSearch();
        self.update();
      });
    }

    if (this.sortBtn) {
      this.sortBtn.addEventListener('click', function () {
        self.setPop(self.sortPop, self.sortBtn, !self.sortPop.classList.contains('is-open'));
      });
    }

    // Outside pointer-down and Esc close any open popover.
    document.addEventListener('pointerdown', function (e) {
      [[self.sortPop, self.sortBtn], [self.barPop, self.barBtn]].forEach(function (pair) {
        if (!pair[0] || !pair[0].classList.contains('is-open')) return;
        if (pair[0].contains(e.target) || pair[1].contains(e.target)) return;
        self.setPop(pair[0], pair[1], false);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      [[self.sortPop, self.sortBtn], [self.barPop, self.barBtn]].forEach(function (pair) {
        if (pair[0] && pair[0].classList.contains('is-open')) {
          self.setPop(pair[0], pair[1], false);
          pair[1].focus();
        }
      });
    });
    [this.sortPop, this.barPop].forEach(function (pop) {
      if (!pop) return;
      pop.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        var opts = Array.prototype.slice.call(pop.querySelectorAll('button'));
        var at = opts.indexOf(document.activeElement);
        e.preventDefault();
        var next = opts[(at + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length];
        if (next) next.focus();
      });
    });

    window.matchMedia('(max-width: 960px)').addEventListener('change', function () {
      self.paintSort();
    });
  };

  Shop.prototype.clearSearch = function () {
    this.state.q = '';
    // Leaving a search drops back into a category, never the whole catalogue.
    if (this.state.cat === 'All') {
      this.state.cat = this.defaultCat;
      this.state.sub = 'All';
    }
  };

  Shop.prototype.renderSorts = function () {
    var self = this;
    var build = function (host) {
      if (!host) return;
      host.innerHTML = SORTS.map(function (d) {
        return (
          '<button type="button" class="hl-pop__opt" role="option" aria-selected="false" data-sort="' + d[0] + '">' +
          '<span>' + esc(d[1]) + '</span><span class="hl-pop__check">' + CHECK + '</span></button>'
        );
      }).join('');
      host.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-sort]');
        if (!opt) return;
        self.state.sort = opt.getAttribute('data-sort');
        self.setPop(self.sortPop, self.sortBtn, false);
        self.setPop(self.barPop, self.barBtn, false);
        self.update();
      });
    };
    build(this.sortPop);
    build(this.barSorts);
  };

  Shop.prototype.setPop = function (pop, btn, open) {
    if (!pop || !btn) return;
    pop.classList.toggle('is-open', open);
    btn.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var sel = pop.querySelector('[aria-selected="true"]') || pop.querySelector('button');
      if (sel) window.setTimeout(function () { sel.focus({ preventScroll: true }); }, 0);
    }
  };

  Shop.prototype.paintSort = function () {
    var d = sortDef(this.state.sort);
    var short = mobile();
    if (this.sortLabel) this.sortLabel.textContent = short ? d[2] : d[1];
    if (this.barSort) this.barSort.textContent = d[2];
    var key = this.state.sort;
    [this.sortPop, this.barSorts].forEach(function (host) {
      if (!host) return;
      Array.prototype.forEach.call(host.querySelectorAll('[data-sort]'), function (b) {
        var on = b.getAttribute('data-sort') === key;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    });
  };

  // Scroll the selected chip into view if it is clipped, in both rows.
  Shop.prototype.revealChip = function () {
    var sub = this.state.sub;
    [this.chips, this.barChips].forEach(function (row) {
      if (!row) return;
      var chip = row.querySelector('[data-sub="' + (window.CSS && CSS.escape ? CSS.escape(sub) : sub) + '"]');
      if (!chip) return;
      var x = chip.offsetLeft;
      var w = chip.offsetWidth;
      if (x < row.scrollLeft || x + w > row.scrollLeft + row.clientWidth - 40) {
        row.scrollTo({ left: Math.max(0, x - 40), behavior: reduced() ? 'auto' : 'smooth' });
      }
    });
  };

  Shop.prototype.paintChipsNext = function () {
    if (!this.chipsNext || !this.chips) return;
    var more = this.chips.scrollLeft + this.chips.clientWidth < this.chips.scrollWidth - 4;
    this.chipsNext.classList.toggle('is-off', !more);
  };

  Shop.prototype.renderChips = function () {
    var s = this.state;
    var present = this.present[s.cat] || {};
    var list = (SUBCATS[s.cat] || []).filter(function (x) {
      return present[x];
    });
    var none = s.cat === 'All' || s.cat === 'New In' || list.length === 0;
    if (none) s.sub = 'All';
    else if (s.sub !== 'All' && list.indexOf(s.sub) === -1) s.sub = 'All';

    var key = s.cat + '|' + list.join('|');
    if (key !== this.chipsKey) {
      this.chipsKey = key;
      var html = none
        ? ''
        : ['All'].concat(list).map(function (x) {
            return '<button type="button" class="hl-chip" aria-pressed="false" data-sub="' + esc(x) + '">' + esc(x === 'All' ? 'All ' + s.cat : x) + '</button>';
          }).join('');
      if (this.chips) this.chips.innerHTML = html;
      if (this.barChips) this.barChips.innerHTML = html;
      if (this.chips) this.chips.scrollLeft = 0;
      if (this.barChips) this.barChips.scrollLeft = 0;
    }
    if (this.chipWrap) this.chipWrap.hidden = none;
    if (this.bar) this.bar.classList.toggle('has-chips', !none);

    [this.chips, this.barChips].forEach(function (row) {
      if (!row) return;
      Array.prototype.forEach.call(row.querySelectorAll('[data-sub]'), function (b) {
        var on = b.getAttribute('data-sub') === s.sub;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
    this.paintChipsNext();
  };

  /* ─────────────── filtering ─────────────── */

  Shop.prototype.matches = function (cell) {
    var s = this.state;
    var dr = cell.getAttribute('data-range');
    if (s.range !== 'all' && dr !== s.range && dr !== 'both') return false;
    if (s.stock && cell.getAttribute('data-instock') !== 'true') return false;
    if (s.q) {
      var hay = cell.getAttribute('data-search') || '';
      var ok = this.loose
        ? window.HLSearchBrain.looseMatch(s.q, hay)
        : s.q.toLowerCase().split(/\s+/).every(function (w) {
            return hay.indexOf(w) > -1;
          });
      if (!ok) return false;
    }
    if (s.cat === 'All') return true;
    if (s.cat === 'New In') return cell.getAttribute('data-newin') === 'true';
    if (cell.getAttribute('data-cat') !== s.cat) return false;
    if (s.sub && s.sub !== 'All') return cell.hlSubs.indexOf(s.sub) > -1;
    return true;
  };

  // "Featured" is the collection's own order; the others reorder on top of
  // it. Moving cells rather than rebuilding keeps each tile's state.
  Shop.prototype.sortCells = function () {
    var sort = this.state.sort;
    var ordered = this.cells.slice();
    if (sort === 'low' || sort === 'high') {
      var dir = sort === 'low' ? 1 : -1;
      ordered.sort(function (a, b) {
        return dir * (Number(a.getAttribute('data-price')) - Number(b.getAttribute('data-price'))) || a.hlIndex - b.hlIndex;
      });
    } else if (sort === 'new') {
      ordered.sort(function (a, b) {
        var na = a.getAttribute('data-newin') === 'true' ? 1 : 0;
        var nb = b.getAttribute('data-newin') === 'true' ? 1 : 0;
        return nb - na || a.hlIndex - b.hlIndex;
      });
    }
    var grid = this.grid;
    ordered.forEach(function (cell) {
      grid.appendChild(cell);
    });
  };

  Shop.prototype.update = function (first) {
    var self = this;
    var s = this.state;
    this.renderChips();

    // Range: hero colours, lens position and labels all hang off this one
    // attribute; see hl-shop.css.
    if (this.hero) this.hero.setAttribute('data-range', s.range);
    if (this.seg) this.seg.setAttribute('data-range', s.range);
    this.segOpts.forEach(function (b) {
      var on = b.getAttribute('data-range') === s.range;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
    if (this.line) this.line.textContent = LINES[s.range];

    this.catBtns.forEach(function (b) {
      var on = b.getAttribute('data-cat') === s.cat;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    this.sortCells();
    var count = function () {
      var n = 0;
      self.cells.forEach(function (cell) {
        var ok = self.matches(cell);
        cell.classList.toggle('is-hidden', !ok);
        if (ok) n++;
      });
      return n;
    };
    // A search that matches nothing exactly tries again loosely: typos and
    // sound-alike spellings ("cowch", "lethar") still find the closest
    // pieces, labelled as the closest rather than as exact results.
    this.loose = false;
    var shown = count();
    if (!shown && s.q && window.HLSearchBrain) {
      var brain = window.HLSearchBrain;
      this.loose = true;
      shown = count();
      if (!shown) this.loose = false;
      // The synonym list arrives with the search intents file; try once
      // more when it lands.
      if (!shown && !brain.loaded() && !this.waitingBrain) {
        this.waitingBrain = true;
        brain.load().then(function () {
          if (self.state.q) self.update();
        });
      }
    }

    var titleText = s.q
      ? (this.loose ? 'Closest matches for “' : 'Results for “') + s.q + '”'
      : s.cat === 'All' ? 'All pieces' : s.cat;
    if (this.title) this.title.textContent = titleText;

    var pieces = shown + ' ' + (shown === 1 ? 'piece' : 'pieces');
    if (this.count) this.count.textContent = 'Showing ' + pieces;
    if (this.barTitle) this.barTitle.textContent = s.q ? 'Results' : titleText;
    if (this.barCount) this.barCount.textContent = pieces;

    // Active-filter tokens; each one clears its own filter.
    if (this.tokens) {
      var t = [];
      if (s.q) t.push(['q', '“' + s.q + '”']);
      if (s.sub !== 'All') t.push(['sub', s.sub]);
      if (s.stock) t.push(['stock', 'In stock']);
      if (s.range !== 'all') t.push(['range', s.range === 'signature' ? 'Signature' : 'Essentials']);
      this.tokens.innerHTML = t.map(function (x) {
        return '<button type="button" class="hl-token" data-clear="' + x[0] + '" aria-label="Remove filter: ' + esc(x[1]) + '"><span>' + esc(x[1]) + '</span>' + X + '</button>';
      }).join('');
    }

    [this.stockBtn, this.barStock].forEach(function (b) {
      if (!b) return;
      b.classList.toggle('is-on', s.stock);
      b.setAttribute('aria-checked', s.stock ? 'true' : 'false');
    });
    if (this.barDot) this.barDot.hidden = !s.stock;
    this.paintSort();

    // Empty: a category with nothing in it at all is "coming soon";
    // anything else is a filter that matched nothing.
    if (shown === 0) {
      var prevLink = this.empty.querySelector('.hl-shop__empty-link');
      if (prevLink && !s.q) prevLink.remove();
      this.empty.hidden = false;
      this.grid.style.display = 'none';
      var unfiltered = !s.q && s.sub === 'All' && !s.stock && s.range === 'all';
      if (!s.q && !this.catSize[s.cat] && this.comingSoon.indexOf(s.cat) > -1 && unfiltered) {
        this.emptyTitle.textContent = s.cat + ' is coming soon';
        this.emptyText.textContent = 'We’re putting the finishing touches on our ' + s.cat.toLowerCase() + ' range. Check back shortly.';
        this.emptyClear.hidden = true;
      } else {
        this.emptyTitle.textContent = 'No pieces match';
        this.emptyText.textContent = s.q
          ? 'Try a different word, or clear your filters.'
          : 'Try a different size or material, or clear your filters.';
        this.emptyClear.hidden = false;
        if (s.q) this.offerShortcut(s.q);
      }
    } else {
      this.empty.hidden = true;
      this.grid.style.display = '';
      var stale = this.empty.querySelector('.hl-shop__empty-link');
      if (stale) stale.remove();
    }

    // Shareable URL, no reload.
    var next = new URLSearchParams();
    if (s.range !== 'all') next.set('range', s.range);
    if (s.cat !== 'All') next.set('cat', s.cat);
    if (s.cat !== 'All' && s.sub !== 'All') next.set('sub', s.sub);
    if (s.stock) next.set('available', '1');
    var sb = sortDef(s.sort)[3];
    if (sb) next.set('sort_by', sb);
    if (s.q) next.set('q', s.q);
    var qs = next.toString();
    var url = location.pathname + (qs ? '?' + qs : '') + location.hash;
    if (url !== location.pathname + location.search + location.hash) history.replaceState(null, '', url);

    if (!first) this.measureBlock();
  };

  // A search for a service rather than a piece ("rubbish removal",
  // "warranty") finds no products here, so point at the page that has it.
  Shop.prototype.offerShortcut = function (q) {
    var self = this;
    var brain = window.HLSearchBrain;
    if (!brain) return;
    brain.load().then(function () {
      if (self.state.q !== q || self.empty.hidden) return;
      var hit = brain.matchIntents(brain.normalise(q), 1)[0];
      var link = self.empty.querySelector('.hl-shop__empty-link');
      if (!hit) {
        if (link) link.remove();
        return;
      }
      if (!link) {
        link = document.createElement('a');
        link.className = 'hl-shop__empty-btn hl-shop__empty-link';
        self.emptyClear.parentNode.insertBefore(link, self.emptyClear);
      }
      link.href = hit.url;
      link.textContent = hit.title;
      self.emptyTitle.textContent = 'Looking for ' + hit.title.toLowerCase() + '?';
      self.emptyText.textContent = hit.description || 'It isn\u2019t a piece of furniture, so it lives on its own page.';
      self.emptyClear.hidden = true;
    });
  };

  /* ─────────────── compact bar ─────────────── */

  Shop.prototype.bindBar = function () {
    var self = this;
    if (!this.bar || !this.block) return;

    if (this.barBtn) {
      this.barBtn.addEventListener('click', function () {
        self.setPop(self.barPop, self.barBtn, !self.barPop.classList.contains('is-open'));
      });
    }

    this.compact = false;
    var ticking = false;
    var check = function () {
      ticking = false;
      var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--hl-header-h'), 10) || 0;
      // How far the filter block's bottom is below the header's bottom.
      var below = self.block.getBoundingClientRect().bottom - headerH;
      // Hysteresis: in at 40px, out at 70px, so it never flickers.
      var compact = self.compact ? below < 70 : below < 40;
      if (compact !== self.compact) self.setCompact(compact);
    };
    this.measureBlock = function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(check);
      }
    };
    window.addEventListener('scroll', this.measureBlock, { passive: true });
    window.addEventListener('resize', this.measureBlock, { passive: true });
    document.addEventListener('hl:header-height', this.measureBlock);
    this.measureBlock();
  };

  Shop.prototype.setCompact = function (on) {
    this.compact = on;
    this.bar.classList.toggle('is-on', on);
    this.bar.inert = !on;
    this.bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    if (on) {
      this.setPop(this.sortPop, this.sortBtn, false);
      this.revealChip();
    } else {
      this.setPop(this.barPop, this.barBtn, false);
    }
  };

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hl-shop]'), function (root) {
      if (root.hlShop) return;
      root.hlShop = new Shop(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
  // The compact bar was moved to <body>; take it with the section it belongs to.
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target && e.target.querySelector('[data-hl-shop]');
    if (root && root.hlShop && root.hlShop.bar && root.hlShop.bar.parentNode) {
      root.hlShop.bar.parentNode.removeChild(root.hlShop.bar);
    }
  });
})();
